import { VERSION } from "../defines";

const Version = () => {
	return <div className="mt-5 text-xs text-dark-100">v{VERSION}</div>;
};

export default Version;
